import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-editable',
  templateUrl: './editable.component.html',
  styleUrls: ['./editable.component.css']
})
export class EditableComponent implements OnInit, OnChanges {

  @Input() editing: boolean;
  @Input() text: string;
  @Input() placeholdText: string;
  @Input() figureno: boolean;
  @Input() titleInput: boolean;
  @Input() defaultText: string;
  editStr: string;

  @Output() edited = new EventEmitter<string>();
  @Output() focused = new EventEmitter<boolean>(true);
  constructor() { }

  ngOnInit() {this.placeholdText="input here"
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('text' in changes) {
      this.editStr = changes.text.currentValue;     
      //console.log(this.figureno) 
    }
	if ('defaultText' in changes) {//console.log(this.defaultText)
      if(!this.defaultText||this.defaultText.length==0){
		 this.defaultText='text'; 
	  }     
      //console.log(this.figureno) 
    }
  }

  onBlur(event) {console.log(event)
    this.editing = false;
    if(this.editStr==''){
      //this.editStr='#';	 
  }
    this.edited.emit(this.editStr);
  }
  nameValidate(event){
    var regex = new RegExp("^[a-zA-Z0-9 ]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
        event.preventDefault();
        return false;
    }
  }
  onFocus(){
	this.focused.emit(true);
  }
}

